import { Box, Collapse,  ListItem, ListItemText, makeStyles } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import clsx from "clsx";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import TopMenuItem from "../functional/TopMenuItem";

const useStyles = makeStyles((theme) => ({
  item: (props) => ({
    paddingTop: 1,
    paddingBottom: 1,
    color: "rgba(255, 255, 255, 0.7)",
    "&:hover,&:focus": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
    },
  }),

  itemActiveItem: {
    color: "#4fc3f7",
  },
  itemPrimary: {
    fontSize: "inherit",
  },
  itemIcon: {
    minWidth: "auto",
    marginRight: theme.spacing(2),
  },
  iconToggle: {
    marginLeft: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
}));
/**
 * @COMPONENT_NAME ContainerTopNestedMenuItems
 * @DESCRIPTION
 * 상위 메뉴 항목 중 컨테이너 역할을 하는 메뉴를 재귀적으로 렌더링하는 컴포넌트입니다.
 * 메뉴 구조가 중첩되어 있기 때문에 재귀 호출을 통해 하위 메뉴를 렌더링
 *
 * @PROPS
 *    - {Object} containerMenuItem - 현재 렌더링 중인 컨테이너 메뉴 항목 객체
 *    - {Array} menuItems - 전체 메뉴 항목 배열
 *
 * @PASSTHROUGH_PROPS
 *    - 없음 (모든 props는 직접 사용됨)
 *
 * @CALLBACKS
 *    - 없음 (내부에서만 상태 관리)
 *
 * @EXAMPLES
 * ```jsx
 * <ContainerTopNestedMenuItems
 *   containerMenuItem={item}
 *   menuItems={allMenuItems}
 * />
 * ```
 */
export default function ContainerTopNestedMenuItems(props) {
  const {
    containerMenuItem,
    menuItems,
  } = props;

  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const handleClick = () => {
    setOpen(!open);
  };
  const childMenuItems = menuItems
    .filter(item => item.parentTopMenuItemId === containerMenuItem.topMenuItemId)
    .sort((a, b) => a.order - b.order);

  return (
    <>
      <ListItem button onClick={handleClick} className={clsx(classes.item)}>
        <ListItemText classes={{ primary: classes.itemPrimary }}>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <span>{t("menu." + containerMenuItem.menuItemName)}</span>
            <span className={classes.iconToggle}>
              {open ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
            </span>
          </Box>
        </ListItemText>
      </ListItem>

      <Collapse in={open} timeout="auto" unmountOnExit>
        {childMenuItems
          .map((item) => {
            switch (item.menuType) {
              case "container":
                return (
                  <ContainerTopNestedMenuItems
                    key={item.topMenuItemId}
                    containerMenuItem={item}
                    menuItems={menuItems}
                  />
                );
              default:
                return <TopMenuItem key={item.topMenuItemId} menuItem={item} />;
            }
          })}
      </Collapse>
    </>
  );
}
